const initialState = {
    template: {},
    isReadingTemplate: false,
 
    isUpdatingTemplate: false,
    isDeletingTemplate: false
}

export default initialState;
